inits.push( "MonthReport.init()" );


window.MonthReport = {
    graphs: [ ],
    init : ( ) => {
        if($ === undefined) {
            window.setTimeout(
                function() {window.MonthReport.init() },
                5000);
            return;
        }

        const _this = window.MonthReport;
        if ( /monatsbericht\/?$/i.test( location.href ) ) {
            var spanInner = new Date( ).toLocaleString( "de-DE", { weekday: 'long', month: '2-digit', year: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' } ) + ' Uhr';
            document.querySelectorAll( 'span.dynDate' ).forEach( function ( el ) {
                el.textContent = spanInner;
            } );
        }
        var hrefHanlder = document.querySelectorAll( '.handler' );
        if ( hrefHanlder.length > 0 ) {
            for ( var i = 0; i < hrefHanlder.length; i++ ) {
                hrefHanlder[ i ].addEventListener( 'click', function ( ) {
                    var href = this.dataset.href;
                    document.body.style.cursor = 'wait';
                    $.ajax( {
                        url: href,
                        method: 'get'
                    } ).done( function ( data ) {
                        document.body.style.cursor = 'default';
                        if ( data === 'ok' ) {
                            if ( href.indexOf( 'parse' ) > 0 ) {
                                tools.toast( 'Monatsbericht', 'Rohdaten wurden aufbereitet' );
                            } else {
                                tools.toast( 'Monatsbericht', 'Ein neuer Monatsbericht wurde erstellt' );
                            }
                        } else {
                            tools.toast( 'Monatsbericht', 'Beim erstellen des Monatsberichtes ist ein Fehler aufgetreten!' );
                        }

                    } );
                } );
            }
        }

        $( '.icon-trash.month' ).each( function ( i, el ) {
            var dlg = $( '<div id="dialog-confirm" title="Monatsbericht Löschen?"><p><span class="ui-icon ui-icon-alert" style="float:left; margin:0 7px 20px 0;"></span>Der Bericht wird permanent gelöscht. Sind Sie sich sicher?</p></div>' );

            $( el ).click( function ( event ) {
                var ref = $( this ).attr( 'data-ref' );
                var $row = $( this ).closest( '.row' );
                dlg.dialog( {
                    resizable: false,
                    height: 150,
                    modal: true,
                    buttons: {
                        "Löschen": function ( ) {
                            _this.go( ref, $row );
                            $( this ).dialog( "close" );
                        },
                        "Abbrechen": function ( ) {
                            $( this ).dialog( "close" );
                        }
                    }
                } );

            } );
        } );

        if ( !$( '.MonthReport' ).length ) {
            return;
        }
        /* Graph initialisieren */
        $( '.MonthReport' ).each( function ( i, el ) {
            var $graphData = MonthReport.getData( '/Handler/Monatsreport', $( el ).attr( 'data-id' ) );
            var aLabels = $graphData.split( '\n' )[ 0 ].split( ',' );
            // aLabels[ 0 ] = "Datum";
            var aGraphData = $graphData.split( '\n' ); //.map(function(el) { return el.split(","); });
            aGraphData.shift( );
            $graphData = aGraphData.join( "\n" );
            var gSeries = {};

            var colorNiederschlag = 'rgb(119, 153, 222)'; // Helleres Blau
            var colorSpeicherinhalt = 'rgb(222,0,0)'; // Dunkles Rot: @base-dark-color #25408f

            aLabels.forEach( function ( label, i ) {
                if ( label === "Niederschlag" || /Niederschlag/.test( label ) ) {
                    gSeries[ label ] = {
                        color: colorNiederschlag,
                        plotter: monthBarChartPlotter,
                        axis: 'y2'
                    };
                }
                if ( ( /speicherinhalt\s\[/i ).test( label ) ) {
                    //                } === "Speicherinhalt" ) {
                    gSeries[ label ] = {
                        color: colorSpeicherinhalt,
                    };
                    gSeries[ aLabels[ i ] ] = {
                        strokeWidth: 3,
                        color: 'rgb(37,64,143)'
                    };
                }
                if ( ( /orientierungslinie/i ).test( label ) ) {
                    aLabels[ i ] = 'Orientierungslinie';
                    gSeries[ aLabels[ i ] ] = {
                        color: 'rgb(200,0,0)',
                        strokeWidth: 2
                    };
                }

                if ( ( /speicherinhalt\-ol/i ).test( label ) ) {
                    aLabels[ i ] = 'Orientierungslinie';
                    gSeries[ aLabels[ i ] ] = {
                        color: 'rgb(200,0,0)',
                        strokeWidth: 2
                    };
                } else if ( ( /speicherinhalt-sr/i ).test( label ) ) {
                    aLabels[ i ] = "Schutzraum";
                    gSeries[ aLabels[ i ] ] = {
                        strokeWidth: 2
                    };
                }

            } );
            var values = $.csv.toArrays( $graphData );
            var max = values.MaxTimeLine( );
            var min = values.MinTimeLine( );
            min = Math.floor( min );
            max = Math.ceil( max );
            var g = new Dygraph(
                el,
                $graphData, {
                    labels: aLabels,
                    series: gSeries,
                    connectSeparatedPoints: true,
                    pointSize: 1,
                    drawPoints: false,
                    gridLineWidth: 0.6,
                    includeZero: true,
                    legendFormatter: MonthReport.legendFormatter,
                    interactionModel: {},
                    highlightSeriesOpts: {
                        strokeWidth: 2,
                        strokeBorderWidth: 1,
                        highlightCircleSize: 3,
                    },
                    axes: {
                        y: {
                            min: 0,
                            minyval: 0,
                            valueFormatter: function ( ms ) {
                                return parseFloat( ms ).toFixed( 2 );
                            }
                        },
                        y2: {
                            min: 0,
                            valueFormatter: function ( ms ) {
                                return parseFloat( ms ).toFixed( 2 ) + 'mm';
                            },
                            ticker: function ( min, max, pixels, opts, dygraph, vals ) {
                                var ticks = [ ];
                                for ( var i = 0; i < vals.length; i++ ) {
                                    ticks.push( { v: vals[ i ], label: '<span title="Niederschlag">' + vals[ i ] + 'mm</span>' } );
                                }
                                return ticks;
                            }
                        },
                        x: {
                            ticker: function ( min, max, pixels, opts, dygraph, vals ) {
                                var tickVals = new Array( );
                                var hDiff = parseInt( ( max - min ) / ( 60 * 60 ) );
                                var mod = ( 24 * 60 * 60 ); // default 24 Stunden Takt
                                if ( hDiff < 72 ) {
                                    mod = ( 6 * 60 * 60 ); // 6 Stunden Takt
                                    //mod = (60 * 60);	// WUP- 480 1 Stunden Takt
                                }
                                if ( hDiff <= 24 ) {
                                    mod = ( 4 * 60 * 60 ); // Stundentakt
                                    //mod = (15 * 60);	            // WUP- 480 15 Minuten Takt
                                }
                                if ( hDiff <= 12 ) {
                                    mod = ( 30 * 60 ); // 30 Minuten
                                }
                                if ( hDiff <= 4 ) {
                                    mod = ( 10 * 60 ); // 10 Minuten
                                }
                                if ( hDiff > 1000 ) { // Montagsbericht hDiff / 300 Tage
                                    mod = parseInt( hDiff / 300 ) * ( 24 * 60 * 60 );
                                }

                                max = parseInt( max );
                                fullData = dygraph.rawData_;
                                var startTS = parseInt( zeroDay( new Date( min * 1000 ) ).getTime( ) / 1000 );
                                while ( startTS <= max ) {
                                    var ts = startTS;
                                    var date = new Date( ts * 1000 );
                                    var month = date.getMonth( ) + 1;
                                    var day = date.getDate( );
                                    var hour = date.getHours( );
                                    min = date.getMinutes( );
                                    month = ( month < 10 ? "0" : "" ) + month;
                                    day = ( day < 10 ? "0" : "" ) + day;
                                    hour = ( hour < 10 ? "0" : "" ) + hour;
                                    min = ( min < 10 ? "0" : "" ) + min;
                                    t = {
                                        v: startTS,
                                        label: '<span class="dia-date" style="font-weight: bold">' + day + '.' + month + '</span><br /><span class="dia-time">' + hour + ":" + min + '</span>'
                                    };
                                    tickVals.push( t );
                                    startTS += ( mod );
                                }
                                return tickVals;

                                //return [{v:1454592420, label:"aaaaaaa"}, {v:1454608500, label:"5"}, {v:1454619960, label:"10"}];
                            },

                            axisLabelFormatter: function ( ts, gran, opts, d ) {
                                var date = new Date( ts * 1000 );
                                var month = date.getMonth( ) + 1;
                                var day = date.getDate( );
                                var hour = date.getHours( );
                                min = date.getMinutes( );
                                month = ( month < 10 ? "0" : "" ) + month;
                                day = ( day < 10 ? "0" : "" ) + day;
                                hour = ( hour < 10 ? "0" : "" ) + hour;
                                min = ( min < 10 ? "0" : "" ) + min;
                                return '<span class="dia-date" style="font-weight: bold">' + day + '.' + month + '</span><br /><span class="dia-time">' + hour + ":" + min + '</span>';
                            },
                            valueFormatter: function ( ts ) {
                                var date = new Date( ts * 1000 );
                                var month = date.getMonth( ) + 1;
                                var day = date.getDate( );
                                var hour = date.getHours( );
                                min = date.getMinutes( );
                                var sec = date.getSeconds( );
                                month = ( month < 10 ? "0" : "" ) + month;
                                day = ( day < 10 ? "0" : "" ) + day;
                                hour = ( hour < 10 ? "0" : "" ) + hour;
                                min = ( min < 10 ? "0" : "" ) + min;
                                sec = ( sec < 10 ? "0" : "" ) + sec;
                                return '<div class="legendTime pull-left" style="width:12em;">' + day + '.' + month + '.' + date.getFullYear( ) + " " + hour + ":" + min + ":" + sec + '</div>';
                            }
                        }
                    }
                }
            );
            ConfigGraph( g );
            MonthReport.graphs.push( g );

        } )
    },
    getData : function ( url, id ) {
        var retData = '';
        if ( location.pathname.match( '/month/' ) ) {
            url = location.pathname.replace( 'index.html', '' );
            url += '../' + id + '.html';
        }
        $.ajax( {
            cache: false,
            type: "GET",
            async: false,
            url: url,
            data: {
                token: id
            }
        } ).done( function ( data ) {
            retData = data;
        } );
        var w = retData.split( '|' );
        if ( w.length > 1 ) {
            // warnwerte vorhanden
            // Warnstufe 1 = Hochwasserwarnung
            // Warnstufe 2 = Hochwasseralarm
            w[ 0 ] = w[ 0 ].replace( 'Warnstufe 1', 'Hochwasserwarnung' );
            w[ 0 ] = w[ 0 ].replace( 'Warnstufe 2', 'Hochwasseralarm' );
            retData = w;
            warnings = w[ 0 ];
        }
        return retData;
    },
    legendFormatter : function ( data ) {
        var html = '<div class="row"><div class="col-xs-12">';
        if ( data.x != null ) {
            var dt = new Date( data.x * 1000 );
            var dtString = ( '0' + dt.getDate( ) ).slice( -2 ) + '.' +
                ( '0' + ( dt.getMonth( ) + 1 ) ).slice( -2 ) + '.' +
                dt.getFullYear( );
            html += dtString;
            // html += dt.toLocaleString();
        }
        html += '&nbsp;</div>';
        // WUPSUPP-268: Langjährig und Speicherinhalt
        var dataDiff = [ ];
        data.series.forEach( function ( series ) {
            if ( !series.isVisible ) return;
            if ( series.labelHTML.match( /Langj.+hrig/ ) ) {
                dataDiff[ 0 ] = ( parseFloat( series.yHTML ? series.yHTML : 0 ) );
            }
            if ( series.labelHTML.match( /Speicherinhalt/ ) ) {
                dataDiff[ 1 ] = ( parseFloat( series.yHTML ? series.yHTML : 0 ) );
            }
            var labeledData = '<div class="col-sm-3" style="color: ' + series.color + '">' + series.labelHTML + ': ' + ( series.yHTML ? series.yHTML : '-' );
            if ( series.isHighlighted ) {
                labeledData = '<b>' + labeledData + '</b>';
            }
            html += labeledData + '</div>';
        } );
        if ( dataDiff[ 1 ] > 0 && dataDiff[ 0 ] > 0 ) {
            var diffP = ( dataDiff[ 1 ] / dataDiff[ 0 ] ) * 100;
            if ( diffP > 100 ) {
                diffP = '+' + ( diffP - 100 ).toFixed( 2 );
            } else {
                diffP = '-' + ( 100 - diffP ).toFixed( 2 );
            }
            var labeledData = '<div class="col-sm-12">Abweichung Inhalt vom langjährigen Mittel: ' + diffP + '%';
            labeledData = '<b>' + labeledData + '</b>';
            html += labeledData + '</div>';
        }
        html = html.replace( 'pull-left', '' );
        return html + '</div>';
    },
    go : function ( ref, row ) {
        $.ajax( {
            cache: false,
            type: "POST",
            url: '/Handler/HvD/Monatsbericht',
            data: {
                data: {
                    'ref': ref
                }
            }
        } ).done( function ( data ) {

            if ( data === 'ok' ) {
                row.remove( );
            }
        } );
    }
};

//region extern-script
/* from WUPSUPP-205 */
function ConfigGraph( g ) {
    var axExt = g.yAxisExtremes( ); // Get Highest and lowest value of Series on both axis
    var y1max = closestNumber( axExt[ 0 ][ 1 ], 10 ); // Get the closest Number to the maximum of axis Y1 that is dividable by 10
    var y2max = axExt[ 1 ][ 1 ]; // Axis Y2 Max without rounding
    var nVal = GetCheckValues( y1max, y2max );
    g.updateOptions( {
        axes: {
            y: {
                valueRange: [ 0, y1max ],
            },
            y2: {
                valueRange: [ 0, nVal ],
            }
        }
    } );
}


/**
 * Find the closest number to n that is dividable by y2Round.
 * The current setup is totally based on y2Round = 10
 *
 * @param {Number} y1max
 * @param {Number} y2Round
 * @returns {Number}
 */
window.closestNumber = ( y1max, y2Round ) => {
    var q = Math.trunc( y1max / y2Round ); // 1st possible closest number
    var n1 = Math.trunc( y2Round * q ); // 2nd possible closest number
    // Finding the two closest No will make one bigger and one smaller than the original Value
    // if true, then n1 is the required closest number
    if ( n1 >= y1max ) {
        return n1;
    }
    return Math.trunc( ( y1max * y2Round ) > 0 ? ( y2Round * ( q + 1 ) ) : ( y2Round * ( q - 1 ) ) );
}


/**
 * Simple function to return an array of numbers that
 * makes sense as Y2 End-Values
 *
 * @param {Number} y1max
 * @param {Number} y2max
 * @returns {Number}
 */
 window.GetCheckValues = ( y1max, y2max ) => {
    /** @type {Number} */
    var nVal = y1max / 10 // Starting value of our search
        /** @type {Number} */
    var security = 0; // Dont get lost in while
    while ( nVal < y2max && security < 25 ) {
        nVal *= 2
        security++;
    }
    return nVal;
}
//endregion

window.monthBarChartPlotter = ( e ) => {
    /*
    var colors = {
        10: 'rgb(37,64,143)',
        5: 'rgb(135,149,193)',
        2: 'rgb(0,123,124)',
        1: 'rgb(255,204,0)',
        0: 'rgb(190,15,63)'
    };
    */
    var ctx = e.drawingContext;
    var points = e.points;
    var y_bottom = e.dygraph.toDomYCoord( 0 );
    var bar_width = 2;
    ctx.fillStyle = 'rgb(119, 153, 222)';

    for ( var i = 0; i < points.length; i++ ) {
        // var p = points[ i ];
        if ( !points[ i ].yval ) {
            continue;
        }
        // for ( var c in colors ) {
        // 	if ( parseFloat( points[ i ].yval ) >= parseFloat( c ) ) {
        // 		ctx.fillStyle = colors[ c ];
        // 	}
        // }
        ctx.fillRect( points[ i ].canvasx - bar_width / 2, points[ i ].canvasy, bar_width, y_bottom - points[ i ].canvasy );
    }
}
